var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 15C14.6028 15 18.3337 10 18.3337 10C18.3337 10 14.6028 5 10.0003 5C5.39783 5 1.66699 10 1.66699 10C1.66699 10 5.39783 15 10.0003 15Z",
    stroke: "#30307D",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 12.0827C10.5529 12.0827 11.0828 11.8632 11.4735 11.4725C11.8642 11.0818 12.0837 10.5519 12.0837 9.99935C12.0837 9.44681 11.8642 8.91691 11.4735 8.52621C11.0828 8.13551 10.5529 7.91602 10.0003 7.91602C9.44779 7.91602 8.91789 8.13551 8.52719 8.52621C8.13649 8.91691 7.91699 9.44681 7.91699 9.99935C7.91699 10.5519 8.13649 11.0818 8.52719 11.4725C8.91789 11.8632 9.44779 12.0827 10.0003 12.0827Z",
    stroke: "#30307D",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9db2232da138592f110e73e4561aa153.svg";
export { ForwardRef as ReactComponent };